import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { tap, take, switchMap, catchError, map, withLatestFrom, filter } from 'rxjs/operators';

import * as fromStore from '../store';
import * as fromRoot from '../../store';
import { Observable, of } from 'rxjs';
import { SetTitle, SetTags } from '../../store';
import { StringUtility } from '@teamfoster/sdk/text-utility';
import { getSettings } from '../../settings/store';

@Injectable({ providedIn: 'root' })
export class DiseaseProfileMetaGuard {
  private store = inject<Store<fromStore.DiseaseProfileState>>(Store);

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getSelectedDiseaseProfileLoaded).pipe(
      withLatestFrom(
        this.store.select(getSettings),
        this.store.select(fromStore.getSelectedDiseaseProfile),
        this.store.select(fromRoot.getRouterState)
      ),
      filter(([loaded, settings, diseaseProfile, router]) => loaded && diseaseProfile?.id === +router.state.params['diseaseProfileId']),
      tap(([loaded, settings, diseaseProfile, router]) => {
        this.store.dispatch(SetTitle({ title: `${diseaseProfile?.metaData.title} - ${settings?.homeMetaData.title}` }));
        this.store.dispatch(
          SetTags({
            properties: {
              'description': StringUtility.Truncate(StringUtility.StripHTML(diseaseProfile?.metaData?.description || ''),
                157,
                '...'
              ),
              'og:image': `https:${diseaseProfile?.metaData.imageUrl}`,
              'og:title': `${diseaseProfile?.metaData.title} - ${settings?.homeMetaData.title}`,
              'og:description': StringUtility.Truncate(StringUtility.StripHTML(diseaseProfile?.metaData?.description || ''),
                157,
                '...'
              ),
            },
          })
        );
      }),
      map(([loaded, settings, diseaseProfile, router]) => loaded && diseaseProfile?.id === +router.state.params['diseaseProfileId']),
      take(1)
    );
  }
}
